import EstoqueImagemService from "@/services/EstoqueImagemService";

export const estoqueImagem = {
  namespaced: true,
  state: {
    estoqueImagem: {},
  },
  actions: {
    getEstoqueImagem({ commit }, payload) {
      return EstoqueImagemService.GetEstoqueImagem(payload).then(
        (estoqueImagem) => {
          return Promise.resolve(estoqueImagem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEstoqueImagem({ commit }, payload) {
      return EstoqueImagemService.PostEstoqueImagem(payload).then(
        (estoqueImagem) => {
          return Promise.resolve(estoqueImagem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEstoqueImagem({ commit }, payload) {
      return EstoqueImagemService.PutEstoqueImagem(payload).then(
        (estoqueImagem) => {
          return Promise.resolve(estoqueImagem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteEstoqueImagem({ commit }, payload) {
      return EstoqueImagemService.DeleteEstoqueImagem(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEstoqueImagemOData({ commit }, payload) {
      return EstoqueImagemService.GetEstoqueImagemOData(payload).then(
        (estoqueImagem) => {
          return Promise.resolve(estoqueImagem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default estoqueImagem;
